<div class="master-list-container">
  <ng-container *ngIf="masters.length; else createMaster">
    <ul class="list-wrapper">
      <li
        *ngFor="let master of masters"
        (click)="selectMaster(master.id)"
        class="master-item"
        [ngClass]="{ 'active-master': selectedMasterId === master.id }"
      >
        <span class="ellipsis">{{ master.label[currentLangId] }}</span>
        <span *ngIf="selectedMasterId === master.id" class="master-arrow" matTooltip="Edit Master" (click)="editMaster($event,master)">
          <img src="assets/icon/edit-icon.svg" alt="">
        </span>
      </li>
    </ul>
  </ng-container>

  <ng-template #createMaster>
    <div class="create-master">No data found. Create your first master.</div>
  </ng-template>
</div>
 <!-- Loading indicator -->
  <ngx-loading
    [show]="isLoading"
    [config]="{ backdropBackgroundColour: 'rgba(255,255,255,0.3)' }"
  ></ngx-loading>
